export const ROLES = Object.freeze({
  USER: "ROLE_USER",
  MANAGER: "ROLE_MANAGER",
  ADMIN: "ROLE_ADMIN",
  HR: "ROLE_HR",
  EMPLOYEE: "ROLE_EMPLOYEE",
  MINION: "ROLE_MINION",
  GUEST: "ROLE_GUEST"
});

export const ALL_APP_ROLES = Object.freeze([
  ROLES.USER,
  ROLES.MANAGER,
  ROLES.ADMIN,
  ROLES.HR,
  ROLES.EMPLOYEE,
  ROLES.MINION
]);
export const STAFF_ROLES = Object.freeze([ROLES.MANAGER, ROLES.HR, ROLES.ADMIN]);
export const EMPLOYEE_SELF_SERVICE_ROLES = Object.freeze([ROLES.EMPLOYEE, ROLES.MINION]);

export const normalizeRoles = roles => {
  if (Array.isArray(roles)) return roles.filter(Boolean);
  if (typeof roles !== "string") return [];
  return roles
    .replace(/[\[\]\s]/g, "")
    .split(",")
    .filter(Boolean);
};

export const hasRole = (roles, role) => normalizeRoles(roles).includes(role);
export const hasAnyRole = (roles, allowedRoles) => {
  const currentRoles = normalizeRoles(roles);
  return allowedRoles.some(role => currentRoles.includes(role));
};
